import axios, { AxiosResponse } from 'axios';
import { AxiosResponseTreatment } from './ChekResponseStatus';

export function http(baseURL: string) {
  axios.defaults.withCredentials = true;

  const instance = axios.create({
    baseURL,
    withCredentials: true,
    validateStatus: () => true,
  });

  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      return AxiosResponseTreatment(response);
    },
    (error) => Promise.reject(new Error(`Произошла техническая ошибка ${error}`))
  );

  instance.interceptors.request.use((value) => {
    return value;
  });

  return instance;
}

export function authServiceApi() {
  return http(`${import.meta.env.VITE_APP_ENDPOINT}/api/v1`);
}

export function authMobileApi() {
  return http(`${import.meta.env.VITE_APP_ENDPOINT}/api/v1/mobile`);
}

export function actionLimitApi() {
  return http(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/optima-action-limit/api/v1/get-application-info-state`);
}

export function o24AccountServiceApi() {
  return http(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/o24-account-service/internal`);
}

export function personalQrApi() {
  return http(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/ob-collaboration-service/api/v1/ob`);
}

export function cardSalaryApi() {
  return http(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/card-salary-service`);
}
